import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const TicketBar = () => {
  const textRef = useRef(null);

  useEffect(() => {
    const chars = textRef.current.querySelectorAll('.char');
    gsap.fromTo(
      chars,
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        stagger: 0.05,
        ease: 'power2.out',
      }
    );
  }, []);

  const text = "Upcoming Live Concert";

  return (
    <div className="bg-[#760af1] dark:bg-gray-700  text-white px-4 py-2 flex  md:flex-row justify-center items-center gap-4">
      <div
        ref={textRef}
        className="flex font-[blanka] flex-wrap justify-center text-sm md:text-xl font-semibold"
      >
        {text.split('').map((char, index) => (
          <span key={index} className="char inline-block">
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </div>
      <a
        href="https://www.bandsintown.com/e/106638754-studio-mercy-at-paca-performing-artists-collective-alliance?came_from=274&utm_medium=web&utm_source=artist_page&utm_campaign=event"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-yellow-400 text-sm md:text-lg text-purple-900 dark:text-gray-700 font-bold px-4 py-1 md:py-2 rounded hover:bg-yellow-300 transition-all duration-300"
      >
        Buy Tickets
      </a>
    </div>
  );
};

export default TicketBar;
